/**
 * WebGL capability detection (TECH_REVIEW_v3_3D — dual render path).
 * The 2D board remains the mandatory fallback when WebGL is unavailable.
 */
let cached: boolean | null = null

export function isWebGLAvailable(): boolean {
  if (cached !== null) return cached
  try {
    const canvas = document.createElement('canvas')
    const gl = canvas.getContext('webgl2') || canvas.getContext('webgl')
    cached = gl !== null
  } catch {
    cached = false
  }
  return cached
}
